/**
 * 存储localStorage
 */
 export const setStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    window.localStorage.setItem(name, content)


  }
  
// export const originalSetItem = localStorage.setItem;
//   localStorage.__proto__.setItem = function(key,newValue){
//         var setItemEvent = new Event("setItemEvent");
//         setItemEvent.newValue = newValue;
//         window.dispatchEvent(setItemEvent);
//         originalSetItem.apply(this,arguments);
//   }
  
  /**
   * 获取localStorage
   */
  export const getStore = name => {
    if (!name) return
    return window.localStorage.getItem(name)
  }
  
  /**
   * 删除localStorage
   */
  export const removeStore = name => {
    if (!name) return
    window.localStorage.removeItem(name)
  }
  